// extracted by mini-css-extract-plugin
export default {"input":"OmniSearch_input__f0qLp","breathing":"OmniSearch_breathing__Rgv6j"};